/* Chrôma Experience — motion + light/dark mode (TEAM ORIGINATOR) */
(function () {
  var root = document.documentElement;
  var KEY = 'chroma-theme';

  /* ---------------- Light / dark switch ---------------- */
  var SWITCH = '<span class="ch-theme-switch__label">Light</span><span class="ch-theme-switch__track" aria-hidden="true"><span class="ch-theme-switch__knob">' +
    '<svg class="ch-sun" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>' +
    '<svg class="ch-moon" viewBox="0 0 24 24"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg></span></span>';
  function addSwitch() {
    document.querySelectorAll('.header__icons').forEach(function (icons) {
      if (icons.querySelector('.ch-theme-switch')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ch-theme-switch';
      b.setAttribute('aria-label', 'Switch between light and dark mode');
      b.innerHTML = SWITCH;
      icons.insertBefore(b, icons.firstChild);
    });
  }
  function setTheme(t, keep) {
    root.setAttribute('data-theme', t);
    if (!keep) { try { localStorage.setItem(KEY, t); } catch (e) {} }
    document.querySelectorAll('.ch-theme-switch').forEach(function (b) {
      b.setAttribute('aria-pressed', t === 'dark' ? 'true' : 'false');
      var l = b.querySelector('.ch-theme-switch__label');
      if (l) l.textContent = t === 'dark' ? 'Dark' : 'Light';
    });
  }
  function ensureSwitch() {
    if (document.querySelector('.ch-theme-switch')) return;
    addSwitch();
    setTheme(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', true);
  }
  ensureSwitch();
  document.addEventListener('DOMContentLoaded', ensureSwitch);
  window.addEventListener('load', ensureSwitch);
  // the header can be (re)rendered after this script runs, so keep the switch in place
  if ('MutationObserver' in window) new MutationObserver(ensureSwitch).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ch-theme-switch');
    if (!btn) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    var canAnimate = document.startViewTransition && root.classList.contains('ch-motion');
    if (!canAnimate) {
      root.classList.add('ch-switching');
      setTheme(next);
      setTimeout(function () { root.classList.remove('ch-switching'); }, 600);
      return;
    }
    var r = btn.getBoundingClientRect();
    var x = r.left + r.width / 2, y = r.top + r.height / 2;
    var R = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
    document.startViewTransition(function () { setTheme(next); }).ready.then(function () {
      root.animate(
        { clipPath: ['circle(0 at ' + x + 'px ' + y + 'px)', 'circle(' + R + 'px at ' + x + 'px ' + y + 'px)'] },
        { duration: 750, easing: 'cubic-bezier(.22,.61,.36,1)', pseudoElement: '::view-transition-new(root)' }
      );
    });
  });

  /* ---------------- Motion ---------------- */
  if (!root.classList.contains('ch-motion') || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.querySelector('main');
    if (!main) return;

    var SKIP = '[class*="ai-chroma-hero"], [class*="marquee"], .scroll-trigger, .ch-no-motion, header, footer, dialog, [role="dialog"], script, style';
    var CANDIDATES = 'h1, h2, h3, h4, p, blockquote, img, video, iframe, form, ul, ol, a[class*="button"], a[class*="btn"], button[class*="button"], ' +
      '[class*="card"], [class*="step"], [class*="item"], [class*="column"], [class*="stat"], [class*="pillar"], [class*="tier"], [class*="quote"], [class*="grid"] > *';

    var picked = [];
    main.querySelectorAll(CANDIDATES).forEach(function (el) {
      if (el.closest(SKIP)) return;
      if (el.matches('input, select, textarea, label, option, svg *')) return;
      for (var i = 0; i < picked.length; i++) { if (picked[i].contains(el)) return; }
      if (!el.getClientRects().length) return;
      if (el.offsetHeight > window.innerHeight * 1.3) return; // very tall wrappers: let children animate instead
      picked.push(el);
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        el.classList.add('ch-in');
        // hand control back to the block's own hover effects once revealed
        setTimeout(function () {
          el.classList.remove('ch-rv', 'ch-in');
          el.style.transitionDelay = '';
        }, 1400 + (parseFloat(el.style.transitionDelay) || 0) * 1000);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    var vh = window.innerHeight;
    picked.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.85) return; // already on screen: show as-is, no flash
      var sibs = picked.filter(function (p) { return p.parentElement === el.parentElement; });
      var idx = sibs.indexOf(el);
      el.style.transitionDelay = (Math.min(idx, 5) * 0.1) + 's';
      el.classList.add('ch-rv');
      io.observe(el);
    });

    // gold shimmer on buttons
    main.querySelectorAll('a[class*="button"], a[class*="btn"], button[class*="button"], button[type="submit"], .button').forEach(function (b) {
      if (b.closest('[class*="marquee"], .ch-no-motion')) return;
      var cs = getComputedStyle(b);
      if (cs.position === 'absolute' || cs.position === 'fixed' || cs.display === 'inline') return;
      b.classList.add('ch-shine');
    });

    // slow zoom on images that sit in a cropped frame
    main.querySelectorAll('img').forEach(function (img) {
      var p = img.parentElement;
      if (!p || img.closest('[class*="ai-chroma-hero"], .ch-no-motion')) return;
      if (getComputedStyle(p).overflow === 'hidden') p.classList.add('ch-zoom');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
